/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactDetailsFilter } from './ContactDetailsFilter';
import {
    ContactDetailsFilterFromJSON,
    ContactDetailsFilterFromJSONTyped,
    ContactDetailsFilterToJSON,
} from './ContactDetailsFilter';

/**
 * 
 * @export
 * @interface ListValueCountsByCategoryRequestContent
 */
export interface ListValueCountsByCategoryRequestContent {
    /**
     * Return analytics on contacts created before this timestamp
     * @type {string}
     * @memberof ListValueCountsByCategoryRequestContent
     */
    from?: string;
    /**
     * Return analytics on contacts after this timestamp
     * @type {string}
     * @memberof ListValueCountsByCategoryRequestContent
     */
    to?: string;
    /**
     * 
     * @type {string}
     * @memberof ListValueCountsByCategoryRequestContent
     */
    primaryField?: string;
    /**
     * 
     * @type {string}
     * @memberof ListValueCountsByCategoryRequestContent
     */
    secondaryField?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListValueCountsByCategoryRequestContent
     */
    additionalFields?: Array<string>;
    /**
     * 
     * @type {Array<ContactDetailsFilter>}
     * @memberof ListValueCountsByCategoryRequestContent
     */
    filters?: Array<ContactDetailsFilter>;
    /**
     * 
     * @type {number}
     * @memberof ListValueCountsByCategoryRequestContent
     */
    limit?: number;
}


/**
 * Check if a given object implements the ListValueCountsByCategoryRequestContent interface.
 */
export function instanceOfListValueCountsByCategoryRequestContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListValueCountsByCategoryRequestContentFromJSON(json: any): ListValueCountsByCategoryRequestContent {
    return ListValueCountsByCategoryRequestContentFromJSONTyped(json, false);
}

export function ListValueCountsByCategoryRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListValueCountsByCategoryRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'primaryField': !exists(json, 'primaryField') ? undefined : json['primaryField'],
        'secondaryField': !exists(json, 'secondaryField') ? undefined : json['secondaryField'],
        'additionalFields': !exists(json, 'additionalFields') ? undefined : json['additionalFields'],
        'filters': !exists(json, 'filters') ? undefined : ((json['filters'] as Array<any>).map(ContactDetailsFilterFromJSON)),
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function ListValueCountsByCategoryRequestContentToJSON(value?: ListValueCountsByCategoryRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': value.from,
        'to': value.to,
        'primaryField': value.primaryField,
        'secondaryField': value.secondaryField,
        'additionalFields': value.additionalFields,
        'filters': value.filters === undefined ? undefined : ((value.filters as Array<any>).map(ContactDetailsFilterToJSON)),
        'limit': value.limit,
    };
}

